import { createSlice } from '@reduxjs/toolkit';

type State = {
  isOpen: boolean;
  subject: string;
}

type Action = {
  payload: string;
}

const initialState: State = {
  isOpen: false,
  subject: ''
};

export const slice = createSlice({
  name: 'contactUs',
  initialState,
  reducers: {
    open: (state: State, action: Action) => {
      state.subject = action.payload;
      state.isOpen = true;
    },
    close: (state: State) => {
      state.isOpen = false;
      state.subject = '';
    }
  },
});

export const { open, close } = slice.actions;

export default slice.reducer;
